import api from "@/lib/api";
import { toast } from "sonner";

// One approval call for every place that approves a trial report; publish=true also puts the role live.
export async function approveTrial(trialId, { publish, title } = {}) {
  try {
    const { data } = await api.post(`/test/trial/${trialId}/approve`, { publish: !!publish });
    if (data.published) toast.success(`${title || "The role"} is live`, { description: "It's on your careers page now." });
    else if (data.publish_error) toast.warning("Approved, but not published yet", { description: data.publish_error });
    else toast.success("Approved");
    return data;
  } catch (e) {
    toast.error(e.response?.data?.detail || "Could not approve");
    return null;
  }
}
